import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { CheckboxComponent } from '../common/checkbox/checkbox-component';
import {
  addRange,
  selectMergeExtractedPages,
  selectSelectedPDF,
  selectSplitRanges,
  toggleMergeExtractedPages,
} from '../pdf-slice';
import { RangeInput } from './pdf-range-input-component';

require('./pdf-custom-range.scss');

export const PDFCustomRangeComponent: React.FC<{}> = () => {
  const dispatch = useAppDispatch();
  const getSelectSplitRanges = useSelector(selectSplitRanges);
  const getSelectMergeExtractedPages = useSelector(selectMergeExtractedPages);
  const getSelectedPDF = useSelector(selectSelectedPDF);

  const handleMergeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(toggleMergeExtractedPages());
  };

  const handleAddRange = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    dispatch(
      addRange({
        fromPage: getSelectedPDF.pages,
        toPage: getSelectedPDF.pages,
      }),
    );
  };

  return (
    <div className="pdf-custom-range__container">
      <div className="pdf-custom-range__ranges-container">
        {getSelectSplitRanges.map((range, i) => (
          <RangeInput range={range} i={i} key={`Range ${i}`} />
        ))}
      </div>
      <div className="pdf-custom-range__button-container">
        <button
          className="pdf-custom-range__add-button"
          onClick={(e) => handleAddRange(e)}
        >
          + Add range
        </button>
      </div>
      <div className="pdf-custom-range__checkbox-container">
        <CheckboxComponent
          checked={getSelectMergeExtractedPages}
          onChange={(e) => handleMergeCheckbox(e)}
          labelText="Merge extracted pages in one file"
        />
      </div>
    </div>
  );
};
